// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ControllerLabelsMessage, ControllerLabelsMessageT } from './controller-labels-message';
import { FirmwareVersionMessage, FirmwareVersionMessageT } from './firmware-version-message';
import { FloorLabelMessage, FloorLabelMessageT } from './floor-label-message';
import { FloorLabelsDataMessage, FloorLabelsDataMessageT } from './floor-labels-data-message';


export enum ElevatorControllerInfoContent {
  NONE = 0,
  FloorLabelMessage = 1,
  FirmwareVersionMessage = 2,
  ControllerLabelsMessage = 3,
  FloorLabelsDataMessage = 4
}

export function unionToElevatorControllerInfoContent(
  type: ElevatorControllerInfoContent,
  accessor: (obj:ControllerLabelsMessage|FirmwareVersionMessage|FloorLabelMessage|FloorLabelsDataMessage) => ControllerLabelsMessage|FirmwareVersionMessage|FloorLabelMessage|FloorLabelsDataMessage|null
): ControllerLabelsMessage|FirmwareVersionMessage|FloorLabelMessage|FloorLabelsDataMessage|null {
  switch(ElevatorControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'FloorLabelMessage': return accessor(new FloorLabelMessage())! as FloorLabelMessage;
    case 'FirmwareVersionMessage': return accessor(new FirmwareVersionMessage())! as FirmwareVersionMessage;
    case 'ControllerLabelsMessage': return accessor(new ControllerLabelsMessage())! as ControllerLabelsMessage;
    case 'FloorLabelsDataMessage': return accessor(new FloorLabelsDataMessage())! as FloorLabelsDataMessage;
    default: return null;
  }
}

export function unionListToElevatorControllerInfoContent(
  type: ElevatorControllerInfoContent, 
  accessor: (index: number, obj:ControllerLabelsMessage|FirmwareVersionMessage|FloorLabelMessage|FloorLabelsDataMessage) => ControllerLabelsMessage|FirmwareVersionMessage|FloorLabelMessage|FloorLabelsDataMessage|null, 
  index: number
): ControllerLabelsMessage|FirmwareVersionMessage|FloorLabelMessage|FloorLabelsDataMessage|null {
  switch(ElevatorControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'FloorLabelMessage': return accessor(index, new FloorLabelMessage())! as FloorLabelMessage;
    case 'FirmwareVersionMessage': return accessor(index, new FirmwareVersionMessage())! as FirmwareVersionMessage;
    case 'ControllerLabelsMessage': return accessor(index, new ControllerLabelsMessage())! as ControllerLabelsMessage;
    case 'FloorLabelsDataMessage': return accessor(index, new FloorLabelsDataMessage())! as FloorLabelsDataMessage;
    default: return null;
  }
}

export type ElevatorControllerInfoContentT =
  | { type: 'NONE'; value: null }
  | { type: 'FloorLabelMessage'; value: FloorLabelMessageT }
  | { type: 'FirmwareVersionMessage'; value: FirmwareVersionMessageT }
  | { type: 'ControllerLabelsMessage'; value: ControllerLabelsMessageT }
  | { type: 'FloorLabelsDataMessage'; value: FloorLabelsDataMessageT };
